import { render, staticRenderFns } from "./PermissaoBatida.vue?vue&type=template&id=03b2aadc"
import script from "./PermissaoBatida.vue?vue&type=script&lang=js"
export * from "./PermissaoBatida.vue?vue&type=script&lang=js"
import style0 from "./PermissaoBatida.vue?vue&type=style&index=0&id=03b2aadc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports